let currentScreenId = null
let refCount = 0

export const acquireScreenId = (screenId) => {
  if (screenId != null) {
    currentScreenId = screenId
    refCount += 1
  }
}

export const releaseScreenId = () => {
  refCount = Math.max(0, refCount - 1)
  if (refCount === 0) {
    currentScreenId = null
  }
}

export const getCurrentScreenId = () => currentScreenId

export const clearCurrentScreenId = () => {
  currentScreenId = null
  refCount = 0
}

// Backward-compatible helpers
export const setCurrentScreenId = acquireScreenId
